module.exports = __webpack_public_path__ + "static/img/3.e82eaee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/3.png
// module id = wrBg
// module chunks = 0